import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgNewOrders = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 51 46" {...props}>
    <g fill="none" fillRule="evenodd" stroke="#979797">
      <rect width={50} height={37.25} x={0.5} y={7.938} rx={4} />
      <path d="m17.5 7.504 16 .075V3.188A2.687 2.687 0 0 0 30.812.5H20.188A2.687 2.687 0 0 0 17.5 3.188v4.316z" />
      <circle cx={27.094} cy={18.594} r={4.781} />
      <path d="m28.271 28.692 14.937-5.734 3.07 7.995-14.938 5.734zM10.625 7.438v36.686m29.75-36.686v36.686" />
    </g>
  </svg>
);
const Memo = memo(SvgNewOrders);
export default Memo;
